import GameStateStore from 'app/src/game/GameStateStore';

export default class ActionResult {
	// Perform any changes to the game state that this result describes.
	// For example, a movement result should update the robot's location.
	public execute(_gameStateStore: GameStateStore): void {
		// Virtual
	}
}
